import QuestionList from './QuestionList';
import AnswerList from './AnswerList';
import CarouselProfile from './Carousel';
import Header from './Header';
import Modal from 'react-modal';
import './login-modal.css';
import React from 'react';
import { Link } from 'react-router-dom';
import agent from '../agent';
import { connect } from 'react-redux';
import qs from 'qs';
import moment from 'moment';

import {
  FOLLOW_USER,
  UNFOLLOW_USER,
  PROFILE_PAGE_LOADED,
  PROFILE_PAGE_UNLOADED
} from '../constants/actionTypes';
import './profile.css';
import Tabs from './Tabs';
import LoginModal from './LoginModal.js'
import SGIDSelectionModal from './SGIDSelectionModal.js'
import BlackoutModal from './BlackoutModal.js';
import { BACKEND_URL } from '../constants/constants.js';
import SGIDPromptModal from './SGIDPromptModal.js'

const EditProfileSettings = props => {
  if (props.isUser) {
    return (
      <Link
        to="/settings"
        className="btn btn-sm btn-outline-secondary action-btn">
        <i className="ion-gear-a"></i> Edit Profile Settings
      </Link>
    );
  }
  return null;
};

Modal.setAppElement('#root')

const mapStateToProps = state => ({
  ...state.articleList,
  currentUser: state.common.currentUser,
  profile: state.profile,
  appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({
  onLoad: payload => dispatch({ type: PROFILE_PAGE_LOADED, payload }),
  onUnload: () => dispatch({ type: PROFILE_PAGE_UNLOADED })
});

class Profile extends React.Component {
  componentWillMount() {
    this.props.onLoad(Promise.all([
      agent.Profile.get(this.props.match.params.username),
    ]));
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  //Sets the sticky bar after tab change and initial render
  componentDidUpdate() {
    var tab_list_height = document.getElementsByClassName('tab-list')[0].offsetHeight;
    var swap_btn_height = document.getElementsByClassName('swap-btn')[0].offsetHeight;
    var tab_list_sort_height = document.getElementsByClassName('tab-list')[1].offsetHeight;
    document.getElementsByClassName('swap-btn')[0].style.top = tab_list_height + "px";
    document.getElementsByClassName('tab-list')[1].style.top = tab_list_height + swap_btn_height + "px";
    document.getElementsByClassName('white-bg')[1].style.top = tab_list_height + swap_btn_height + "px";
  }

  constructor(props) {
    super(props);

    if (props.currentUser && props.currentUser.openid && !props.currentUser.preferredName) {
      this.state = {
        showSGIDModal: true,
        timeBurndown: null,
        blackout: false
      };
    } else {
      this.state = {
        showSGIDModal: false,
        timeBurndown: null,
        blackout: false
      };
    }
  }

  openLoginPrompt = () => {
    if (!this.props.currentUser) {
      this.refs.modal.openLoginPrompt(this.props.profile.handle)
    } else if (this.props.currentUser && !this.props.currentUser.verified) {

    } else if (this.props.currentUser && this.props.currentUser.verified && !this.props.currentUser.openid) {
      this.refs.SGIDPromptModal.openLoginPrompt(this.props.profile.handle)
    } else if (this.props.currentUser && this.props.currentUser.verified && this.props.currentUser.openid && !this.props.currentUser.preferredName) {
      this.refs.SGIDSelectionModal.openLoginPrompt()
    }
  }

  openBlankoutModal = () => {
    this.refs.BlackoutModal.openBlackoutFeedback();

  }

  changeBlackout() {
    //For some weird reason, this isn't changing state unless I force a re-render
    this.setState(prevState => ({
      blackout: !prevState.blackout
    }));
    //just force a re-render
    this.forceUpdate();
    //Force window to reload
    window.location.reload();
  }

  render() {
    const currentUser = this.props.currentUser;
    const profile = this.props.profile;
    if (!profile || !profile.startDate || !profile.startTime) {
      return null;
    }
    const handleClick = ev => {
      ev.preventDefault();
      if (this.props.currentUser && this.props.currentUser.verified && this.props.currentUser.openid && this.props.currentUser.preferredName) {
        if (profile.blackout) {
          this.openBlankoutModal();
        } else {
          window.location.href = `/editor/${profile.handle}`
        }
      } else {
        this.openLoginPrompt()
      }
    };

    profile.timeBurndown = moment.duration(profile.timeBurndown);

    //Render AMA button. If board owner == current logged in user, remove button. Else, consider blackouts
    let ama;
    if (currentUser.id == profile.userId) {
      ama = <div />
    } else if (!profile.blackout) {
      ama = <div className="profile-ask" onClick={handleClick}>Ask Me Anything!</div>
    } else {
      ama = <div className="profile-ask-blackout" onClick={handleClick}>Ask Me Anything!</div>
    }

    return (
      <div className="container-background" >
        <div className="container-md">
          <Header
            appName={this.props.appName}
            currentUser={this.props.currentUser} />
          <div className="profile-page">
            <div className="profile-header">
              <div className="profile-info">
                <img src={profile.image} className="profile-img" />
                <div className="profile-username">{profile.name}</div>
                <div className="profile-bio">{profile.bio}</div>
              </div>
              <div className="profile-carousel">
                <CarouselProfile changeBlackout={this.changeBlackout.bind(this)} timeBurndown={profile.timeBurndown} blackout={profile.blackout} startTime={profile.startTime} startDate={profile.startDate} answeringFrequency={profile.answeringFrequency} popularTopics={profile.popularTopics} responseCount={profile.responseCount}
                  viewCount={profile.viewCount} followerCount={profile.followerCount} questionCount={profile.questionCount} answeringCount={profile.answeringCount}> Hello </CarouselProfile>
              </div>
              {ama}
              <hr
              style={{
                border: "0.5px solid rgba(0, 0, 0, 0.1)",
                width: "80%"
              }}
            />
            </div>
            
            <div className="qn-ans-swapper">
              <Tabs>
                <div label="Questions">
                  <div className="swap-btn">
                    <div className="swap-icon-left">
                      <i className='bx bx-chevron-down'></i>
                    </div>
                  </div>
                  <div className="sort-order-swapper">
                    <Tabs>
                      <div label="Top Voted">
                        {
                          profile.handle &&
                          <QuestionList
                            currentUser={this.props.currentUser}
                            handleLogin={this.openLoginPrompt}
                            handleBlackout={this.openBlankoutModal}
                            blackout={profile.blackout}
                            filter='vote'
                            username={profile.handle} />
                        }
                      </div>
                      <div label="Most Recent">
                        {
                          profile.handle &&
                          <QuestionList
                            currentUser={this.props.currentUser}
                            handleLogin={this.openLoginPrompt}
                            handleBlackout={this.openBlankoutModal}
                            blackout={profile.blackout}
                            filter='time'
                            username={profile.handle} />
                        }
                      </div>
                    </Tabs>
                  </div>
                </div>

                <div label="Responses">
                  <div className="swap-btn">
                    <div className="swap-icon-right">
                      <i className='bx bx-chevron-down'></i>
                    </div>
                  </div>
                  <div className="sort-order-swapper">
                    <Tabs>
                      <div label="Trending">
                        {
                          profile.handle &&
                          <AnswerList
                            currentUser={this.props.currentUser}
                            handleLogin={this.openLoginPrompt}
                            handleBlackout={this.openBlankoutModal}
                            blackout={profile.blackout}
                            filter='vote'
                            profile={profile} />
                        }
                      </div>
                      <div label="Most Recent">
                        {
                          profile.handle &&
                          <AnswerList
                            currentUser={this.props.currentUser}
                            handleLogin={this.openLoginPrompt}
                            handleBlackout={this.openBlankoutModal}
                            blackout={profile.blackout}
                            filter='time'
                            profile={profile} />
                        }
                      </div>
                    </Tabs>
                  </div>
                </div>
              </Tabs>
            </div>

            <LoginModal container={this} ref="modal" />
            <SGIDPromptModal container={this} ref="SGIDPromptModal" />
            <SGIDSelectionModal container={this} ref="SGIDSelectionModal" isOpen={this.state.showSGIDModal} currentUser={this.props.currentUser} />
            <BlackoutModal container={this} ref="BlackoutModal" />

          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
export { Profile, mapStateToProps }



// WEBPACK FOOTER //
// ./src/components/Profile.js